import { FilterTransformer } from "../../filters";
import type { VehicleTypeDTO } from "../dtos";
import type { SearchApiResponseDTO } from "../dtos/api/search-api-response.dto";
import type { FetchItemsReturnDTO } from "../dtos/fetch-items-return.dto";
import { DealerTransformer } from "./dealer.transformer";
import { URLTransformer } from "./url.transformer";

export abstract class SearchTransformer {
  static transform({
    params,
    vehicleType,
    actualPage,
    displayPerPage,
    photoPath,
    baseURL,
  }: {
    params: SearchApiResponseDTO;
    vehicleType: VehicleTypeDTO;
    actualPage?: string | number;
    displayPerPage?: number;
    photoPath: string;
    baseURL: string;
  }): FetchItemsReturnDTO {
    const currentPage = (actualPage && Number(actualPage)) || 1;
    return {
      count: params?.Count ?? 0,
      actualPage: currentPage,
      nextPage: currentPage + 1,
      hasNextPage: params.SearchResults.length === displayPerPage,
      dealerInfo: DealerTransformer.transform(params),
      data: params.SearchResults.map((item, index) => {
        return {
          id: String(
            item.MediaZeroKm
              ? `OEM-${item.Specification.Version.id}${index}`
              : item.UniqueId,
          ),
          dealerId: item.Seller?.Id ?? 0,
          title: `${item.Specification.Make.Value} ${item.Specification.Model.Value}`,
          description: item.Specification?.Version?.Value ?? "",
          price: String(item.Prices.Price),
          location: `${item.Seller?.City || ""} ${
            item.Seller?.State?.split(" ")?.pop() ?? ""
          }`,
          odometer: item.MediaZeroKm
            ? "0"
            : String(item.Specification.Odometer),
          year: `${
            !item.MediaZeroKm
              ? `${String(item.Specification.YearFabrication)}/`
              : ""
          }${String(item.Specification.YearModel)}`,
          images:
            item.Media?.Photos?.map((photo) =>
              item.MediaZeroKm
                ? photo.PhotoPath
                : `${photoPath}/_fotos/anunciousados/gigante/${photo.PhotoPath}`,
            ) ?? [],
          noPhoto:
            "https://webmotors.com.br/assets/img/webp/vehicle_no_photo.webp?t=1.0.1",
          url: item.MediaZeroKm
            ? item.AdvertisementLink!
            : `${baseURL}/${URLTransformer.transform(item, vehicleType)}`,
          inspected: item.IsElegibleVehicleInspection,
          view360: item.IsElegible360View,
          hotDeal:
            item?.HotDeal?.map((deal) => ({
              id: deal.Id || "",
              value: deal.Value || "",
            })) || null,
          mediaZeroKm: item.MediaZeroKm,
          isGoodDeal: !!item.GoodDeal,
          isCtaWhatsApp: item.Seller?.IsCtaWhatsApp ?? false,
        };
      }),
      filters: FilterTransformer.transform(params.Filters, vehicleType),
      filtersGrouped:
        params.FiltersGrouped != null && params.FiltersGrouped.length > 0
          ? FilterTransformer.transform(params.FiltersGrouped, vehicleType, {
              preserveApiItemOrder: true,
            })
          : [],
      SEO: params.SEO,
    };
  }
}
